import type { AxiosResponse } from 'axios';

export async function parseResponse({ data: responseData }: AxiosResponse) {
  const hasPartialData = Boolean(
    responseData && responseData.data && typeof responseData.data === 'object' && Object.keys(responseData.data).length,
  );

  /**
   * If the response DOES NOT have any partial data, throw an error and return a promise rejection.
   * Else, if there is data with zero errors or partial data with errors, return the data back
   * to the client. A response with partial data and errors SHOULD NOT be treated as a critical error
   * that does not send data back to the client.
   */
  if (!hasPartialData && responseData.errors && Array.isArray(responseData.errors) && responseData.errors.length) {
    throw new Error(responseData.errors[0].code);
  }

  return responseData;
}
